import React from 'react';
import { ChevronDown, Settings } from 'lucide-react';
import { useUser } from '../../context/UserContext';

/**
 * Header Component для Mail.ru
 * Верхняя навигация с меню проектов и пользователем
 */
export const Header = () => {
  const { userEmail } = useUser();
  const projects = [
    { name: 'Mail', url: 'https://mail.ru/' },
    { name: 'Почта', url: 'https://e.mail.ru/' },
    { name: 'Облако', url: 'https://cloud.mail.ru/' },
    { name: 'Одноклассники', url: 'https://ok.ru/' },
    { name: 'ВКонтакте', url: 'https://vk.com/', badge: '95' },
    { name: 'Новости', url: 'https://news.mail.ru/' },
    { name: 'Знакомства', url: 'https://love.mail.ru/' },
    { name: 'Игры', url: 'https://vkplay.ru/' }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white">
      {/* Верхняя панель навигации */}
      <div className="bg-[#f6f7f8] h-9 px-3 flex items-center justify-between">
        <nav className="flex items-center gap-0">
          {projects.map((project, index) => (
            <a
              key={index}
              href={project.url}
              className="px-2 py-1 text-[#2c2d2e] text-[13px] hover:bg-white/50 rounded-lg transition-colors flex items-center gap-1"
            >
              {project.name}
              {project.badge && (
                <span className="bg-[#0077ff] text-white text-[11px] px-1 py-0.5 rounded-full leading-none">
                  {project.badge}
                </span>
              )}
            </a>
          ))}
          <button className="px-2 py-1 text-[#2c2d2e] text-[13px] hover:bg-white/50 rounded-lg transition-colors flex items-center gap-1">
            Все проекты
            <ChevronDown size={14} />
          </button>
        </nav>

        {/* Пользователь */}
        <div className="flex items-center gap-2 text-[#2c2d2e] text-[13px]">
          <div className="flex items-center gap-2 px-2 py-1 hover:bg-white/50 rounded-lg transition-colors cursor-pointer">
            <div className="w-4 h-4 bg-gradient-to-br from-blue-400 to-blue-600 rounded-lg" />
            <span>{userEmail || 'Загрузка...'}</span>
            <Settings size={16} />
          </div>
        </div>
      </div>

      {/* Логотип */}
      <div className="bg-[#f6f7f8] h-14 px-4 flex items-center">
        <a href="https://mail.ru/" className="flex items-center gap-2">
          <img src="/logo_dark_mail.svg.svg" alt="Mail.ru" className="h-8" />
        </a>
      </div>
    </header>
  );
};

export default Header;